export default {"src":"/_next/static/media/Industrial.8c85aa75.svg","height":50,"width":50};